export default __webpack_public_path__ + "static/media/DITRIBUCION_CARACTERISTICAS_IMG.119cdd80.png";